import React, { useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import PortLogEPSCoverPage from './PortLogEPSCoverPage';
import { useOnScrollToTop } from 'hooks/useScrollToTop';
import { ETenantName } from 'redux/app/vessel/inspector/types';
import { IStore } from 'redux/store';
import { vesselSelectors } from 'redux/app/vessel';
import { commonUtils } from 'redux/_common';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type PortLogInpectorViewProps = PropsFromRedux & OwnProps;
function PortLogInpectorView(props: PortLogInpectorViewProps) {
    const { tenantName, selectedDate, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);
    return (
        <div className="w-full">
            <div className="h-0" ref={topDivRef} />
            {[ETenantName.EPS, ETenantName.DEFAULT]?.includes(tenantName) ? (
                <PortLogEPSCoverPage vesselId={vesselId} selectedDate={selectedDate} />
            ) : null}
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
	const tenantName: ETenantName = commonUtils.getTenantInfo(vesselInfo.tenantId ?? "") as ETenantName;
    return {
        tenantName,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(PortLogInpectorView);
